import dynamic from 'next/dynamic'
import { PropertyRecordsIcon } from 'src/components/insights/icons/property-records'
import { InsightBuilderWidget } from 'src/types/insight-builder'
import preview from 'src/assets/images/widgets-previews/property-debts.png'

const PropertyDebts = dynamic(() => import('src/components/insights/property-records/property-debts'), { ssr: false })

export const PropertyDebtsWidget: InsightBuilderWidget = {
  id: 'property-debts',
  name: 'Property Debts',
  type: 'Property Records',
  icon: PropertyRecordsIcon,
  component: PropertyDebts,
  supportedResultTypes: ['alphamap-location'],
  preview,
  minTier: 'entry',
}
